/* eslint-disable camelcase */
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import getLocalizedUrl from 'lib/utils/getLocalizedUrl';

const generateGeoHrefLangs = (rentalData, currentLocale) => {
  let canonicalLink = '';
  const pageNumber = rentalData?.pagination?.current_page;
  const hrefLangs = Object.entries(mapNamedLocaleToLocale).map(
    ([namedLocale, standardLocale]) => {
      let url = '';
      [
        rentalData.selected_filters.vehicle_make
          || rentalData.selected_filters.vehicle_type,
        rentalData.selected_filters.vehicle_model,
        rentalData.selected_filters.pickup_place,
      ].forEach((selectedFilter) => {
        if (!selectedFilter) return;
        const { slug_translations } = selectedFilter;
        let slugTranslation = slug_translations?.find(
          (item) => item.locale === standardLocale,
        );
        if (!slugTranslation) {
          slugTranslation = slug_translations?.find(
            (item) => item.locale === 'en',
          ) || { slug: selectedFilter?.slug };
        }
        url += slugTranslation.slug ? `/${slugTranslation.slug}` : '';
      });
      url += pageNumber && pageNumber > 1 ? `?page=${pageNumber}` : '';
      if (namedLocale === currentLocale) {
        canonicalLink = getLocalizedUrl(url, namedLocale);
      }
      return {
        url: getLocalizedUrl(url, namedLocale),
        hreflang: standardLocale === 'en' ? 'x-default' : standardLocale,
      };
    },
  );
  return {
    canonical: canonicalLink,
    urls: hrefLangs,
  };
};

export default generateGeoHrefLangs;
